//#region src/components/Icon/registry.ts
var icons = {
	"alert-circle": [
		["circle", {
			cx: "12",
			cy: "12",
			r: "10"
		}],
		["line", {
			x1: "12",
			x2: "12",
			y1: "8",
			y2: "12"
		}],
		["line", {
			x1: "12",
			x2: "12.01",
			y1: "16",
			y2: "16"
		}]
	],
	"alert-triangle": [
		["path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" }],
		["path", { d: "M12 9v4" }],
		["path", { d: "M12 17h.01" }]
	],
	"arrow-down": [["path", { d: "M12 5v14" }], ["path", { d: "m19 12-7 7-7-7" }]],
	bell: [["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }], ["path", { d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" }]],
	calendar: [
		["path", { d: "M8 2v3" }],
		["path", { d: "M16 2v3" }],
		["rect", {
			x: "3",
			y: "3",
			width: "18",
			height: "18",
			rx: "2"
		}],
		["path", { d: "M3 9h18" }]
	],
	check: [["path", { d: "M20 6 9 17l-5-5" }]],
	"check-circle": [["circle", {
		cx: "12",
		cy: "12",
		r: "10"
	}], ["path", { d: "m16 9-5.5 5.5L8 12" }]],
	"chevron-down": [["path", { d: "m6 9 6 6 6-6" }]],
	"chevron-left": [["path", { d: "m15 18-6-6 6-6" }]],
	"chevron-right": [["path", { d: "m9 18 6-6-6-6" }]],
	"chevron-up": [["path", { d: "m18 15-6-6-6 6" }]],
	"chevrons-up-down": [["path", { d: "m7 15 5 5 5-5" }], ["path", { d: "m7 9 5-5 5 5" }]],
	copy: [["rect", {
		width: "14",
		height: "14",
		x: "8",
		y: "8",
		rx: "2",
		ry: "2"
	}], ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" }]],
	"credit-card": [
		["rect", {
			width: "20",
			height: "14",
			x: "2",
			y: "5",
			rx: "2"
		}],
		["line", {
			x1: "2",
			x2: "22",
			y1: "10",
			y2: "10"
		}],
		["path", { d: "M6 14h2" }]
	],
	download: [
		["path", { d: "M12 15V3" }],
		["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }],
		["path", { d: "m7 10 5 5 5-5" }]
	],
	"external-link": [
		["path", { d: "M15 3h6v6" }],
		["path", { d: "M10 14 21 3" }],
		["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }]
	],
	eye: [["path", { d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" }], ["circle", {
		cx: "12",
		cy: "12",
		r: "3"
	}]],
	file: [["path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }], ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }]],
	filter: [["path", { d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" }]],
	grip: [
		["circle", {
			cx: "9",
			cy: "12",
			r: "1"
		}],
		["circle", {
			cx: "9",
			cy: "5",
			r: "1"
		}],
		["circle", {
			cx: "9",
			cy: "19",
			r: "1"
		}],
		["circle", {
			cx: "15",
			cy: "12",
			r: "1"
		}],
		["circle", {
			cx: "15",
			cy: "5",
			r: "1"
		}],
		["circle", {
			cx: "15",
			cy: "19",
			r: "1"
		}]
	],
	home: [["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" }], ["path", { d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }]],
	info: [
		["circle", {
			cx: "12",
			cy: "12",
			r: "10"
		}],
		["path", { d: "M12 16v-4" }],
		["path", { d: "M12 8h.01" }]
	],
	loader: [
		["path", { d: "M12 2v4" }],
		["path", { d: "m16.2 7.8 2.9-2.9" }],
		["path", { d: "M18 12h4" }],
		["path", { d: "m16.2 16.2 2.9 2.9" }],
		["path", { d: "M12 18v4" }],
		["path", { d: "m4.9 19.1 2.9-2.9" }],
		["path", { d: "M2 12h4" }],
		["path", { d: "m4.9 4.9 2.9 2.9" }]
	],
	lock: [["rect", {
		width: "18",
		height: "11",
		x: "3",
		y: "11",
		rx: "2",
		ry: "2"
	}], ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }]],
	"log-out": [
		["path", { d: "m16 17 5-5-5-5" }],
		["path", { d: "M21 12H9" }],
		["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }]
	],
	megaphone: [
		["path", { d: "M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" }],
		["path", { d: "M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14" }],
		["path", { d: "M8 6v8" }]
	],
	menu: [
		["path", { d: "M4 5h16" }],
		["path", { d: "M4 12h16" }],
		["path", { d: "M4 19h16" }]
	],
	minus: [["path", { d: "M5 12h14" }]],
	"more-horizontal": [
		["circle", {
			cx: "12",
			cy: "12",
			r: "1"
		}],
		["circle", {
			cx: "19",
			cy: "12",
			r: "1"
		}],
		["circle", {
			cx: "5",
			cy: "12",
			r: "1"
		}]
	],
	"more-vertical": [
		["circle", {
			cx: "12",
			cy: "12",
			r: "1"
		}],
		["circle", {
			cx: "12",
			cy: "5",
			r: "1"
		}],
		["circle", {
			cx: "12",
			cy: "19",
			r: "1"
		}]
	],
	package: [
		["path", { d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" }],
		["path", { d: "M12 22V12" }],
		["polyline", { points: "3.29 7 12 12 20.71 7" }],
		["path", { d: "m7.5 4.27 9 5.15" }]
	],
	plus: [["path", { d: "M5 12h14" }], ["path", { d: "M12 5v14" }]],
	search: [["path", { d: "m21 21-4.34-4.34" }], ["circle", {
		cx: "11",
		cy: "11",
		r: "8"
	}]],
	settings: [["path", { d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915" }], ["circle", {
		cx: "12",
		cy: "12",
		r: "3"
	}]],
	trash: [
		["path", { d: "M10 11v6" }],
		["path", { d: "M14 11v6" }],
		["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }],
		["path", { d: "M3 6h18" }],
		["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }]
	],
	upload: [
		["path", { d: "M12 3v12" }],
		["path", { d: "m17 8-5-5-5 5" }],
		["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }]
	],
	user: [["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }], ["circle", {
		cx: "12",
		cy: "7",
		r: "4"
	}]],
	users: [
		["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
		["path", { d: "M16 3.128a4 4 0 0 1 0 7.744" }],
		["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }],
		["circle", {
			cx: "9",
			cy: "7",
			r: "4"
		}]
	],
	x: [["path", { d: "M18 6 6 18" }], ["path", { d: "m6 6 12 12" }]]
};
//#endregion
export { icons };

//# sourceMappingURL=registry.js.map